// extracted by css-extract-rspack-plugin
export default {"categories":"Categories-module__categories--eanNU","low-priority":"Categories-module__low-priority--zEICP"};